<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" *ngIf="isCreate">Yeni Banka Hesabı</h4>
  <h4 class="modal-title" id="modal-basic-title" *ngIf="!isCreate">Banka Hesabını Güncelle</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="alert alert-info" *ngIf="hintText">{{ hintText }}</div>
  <div class="mb-3">
    <label for="bankId">Banka <span class="text-danger" ngbTooltip="Zorunlu alan">*</span></label>
    <div class="input-group">
      <select id="bankId" name="bankId" class="form-control form-select" [(ngModel)]="request.bankId">
        <option [ngValue]="undefined">...Banka Seçiniz...</option>
        <option *ngFor="let item of banks" [ngValue]="+item.value">{{ item.text }}</option>
      </select>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="mb-3">
        <label for="branchCode">Şube Kodu</label>
        <div class="input-group">
          <input id="branchCode" type="text" class="form-control" autocomplete="off" [(ngModel)]="request.branchCode" />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="mb-3">
        <label for="branchName">Şube Adı</label>
        <div class="input-group">
          <input id="branchName" type="text" class="form-control" autocomplete="off" [(ngModel)]="request.branchName" />
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3">
    <label for="accountNumber">Hesap No</label>
    <div class="input-group">
      <input id="accountNumber" type="text" class="form-control" autocomplete="off" [(ngModel)]="request.accountNumber" />
    </div>
  </div>

  <div class="mb-3">
    <label for="iban">Iban</label>
    <div class="input-group">
      <input id="iban" type="text" class="form-control" placeholder="TR..." autocomplete="off" [(ngModel)]="request.iban" />
    </div>
  </div>

  <div class="mb-3">
    <label for="currencyCode">Para Birimi <span class="text-danger" ngbTooltip="Zorunlu alan">*</span></label>
    <div class="input-group">
      <select id="currencyCode" name="currencyCode" class="form-control form-select" [(ngModel)]="request.currencyCode">
        <option [ngValue]="undefined">...Para Birimi Seçiniz...</option>
        <option *ngFor="let item of currencyCodes" [ngValue]="item">{{ item }}</option>
      </select>
    </div>
  </div>

  <div class="mb-3">
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="linkEnabled" [(ngModel)]="linkEnabled" (ngModelChange)="linkEnabledChanged()">
      <label class="form-check-label" for="linkEnabled">Hesap Bağlantısı</label>
    </div>
  </div>

  <ng-container *ngIf="linkEnabled">
    <div class="mb-3">
      <label>Bağlantı Türü <span class="text-danger" ngbTooltip="Zorunlu alan">*</span></label>
      <div class="input-group">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="linkTypeCase" name="linkType" value="case" [(ngModel)]="linkType" (ngModelChange)="linkTypeChanged()">
          <label class="form-check-label" for="linkTypeCase">Kasaya Bağlı</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="linkTypeCustomer" name="linkType" value="customer" [(ngModel)]="linkType" (ngModelChange)="linkTypeChanged()">
          <label class="form-check-label" for="linkTypeCustomer">Müşteriye Bağlı</label>
        </div>
      </div>
    </div>

    <div class="mb-3" *ngIf="linkType === 'case'">
      <label for="caseId">Kasa <span class="text-danger" ngbTooltip="Zorunlu alan">*</span></label>
      <div class="input-group">
        <select id="caseId" name="caseId" class="form-control form-select" [(ngModel)]="request.caseId">
          <option [ngValue]="undefined">...Kasa Seçiniz...</option>
          <option *ngFor="let item of cases" [ngValue]="+item.value">{{ item.text }}</option>
        </select>
      </div>
    </div>

    <ng-container *ngIf="linkType === 'customer'">
      <div class="mb-3">
        <label>Müşteri Kaynağı</label>
        <div class="input-group">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" id="customerModeExisting" name="customerMode" value="existing" [(ngModel)]="customerMode" (ngModelChange)="customerModeChanged()">
            <label class="form-check-label" for="customerModeExisting">Kayıtlı Müşteri</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" id="customerModeNew" name="customerMode" value="new" [(ngModel)]="customerMode" (ngModelChange)="customerModeChanged()">
            <label class="form-check-label" for="customerModeNew">Yeni Müşteri</label>
          </div>
        </div>
      </div>

      <div class="mb-3" *ngIf="customerMode === 'existing'">
        <label for="customerId">Müşteri <span class="text-danger" ngbTooltip="Zorunlu alan">*</span></label>
        <div class="input-group">
          <select id="customerId" name="customerId" class="form-control form-select" [(ngModel)]="request.customerId">
            <option [ngValue]="undefined">...Müşteri Seçiniz...</option>
            <option *ngFor="let item of customers" [ngValue]="+item.value">{{ item.text }}</option>
          </select>
        </div>
      </div>

      <ng-container *ngIf="customerMode === 'new'">
        <div class="mb-3">
          <label for="newCustomerName">Müşteri Adı <span class="text-danger" ngbTooltip="Zorunlu alan">*</span></label>
          <div class="input-group">
            <input id="newCustomerName" type="text" class="form-control" autocomplete="off" [(ngModel)]="request.newCustomerName" />
          </div>
        </div>
        <div class="mb-3">
          <label for="newCustomerDisplayName">Kısa Adı</label>
          <div class="input-group">
            <input id="newCustomerDisplayName" type="text" class="form-control" autocomplete="off" [(ngModel)]="request.newCustomerDisplayName" />
          </div>
        </div>
        <div class="mb-3">
          <label for="newCustomerPhone">Telefon</label>
          <div class="input-group">
            <input id="newCustomerPhone" type="text" class="form-control" autocomplete="off" [(ngModel)]="request.newCustomerPhone" />
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="onSubmit()">Kaydet</button>
  <button type="button" class="btn btn-secondary" [disabled]="isDisabled" (click)="activeModal.dismiss()">Geri Dön</button>
</div>
